module.exports = "/assets/dist/images/cs_logo_white.png?28a21e9729d5fe6dac654c2c169c6fbb";